import { DefaultTheme } from "styled-components";

export const lightTheme: DefaultTheme = {
  logoColors: {
    bigTitle: "#0b0d0d",
    smallTitle: "#4529e6",
  },
  backgroundColors: {
    generalBackground: "#F1F3F5",
    headerBackground: "#FDFDFD",
    secondaryBackground: "#FDFDFD",
    bannerBackground: "#5126EA",
  },
  borders: {
    headerBorder: "#DEE2E6",
  },
  textColors: {
    title: "#FDFDFD",
    subTitle: "#000000",
    primaryText: "#495057",
    secondaryText: "#FFFFFF",
    spantext: "#212529",
  },
  buttons: {
    primary: {
      color: "#FFFFFF",
      border: "transparent",
      background: "#4529E6",
      hover: "#5126EA",
    },
    default: {
      color: "#FFFFFF",
      border: "#0B0D0D",
      background: "#0B0D0D",
      hover: "#212529",
    },
    negative: {
      color: "#495057",
      border: "#DEE2E6",
      background: "#DEE2E6",
      hover: "#CED4DA",
    },
    disable: {
      color: "#FFFFFF",
      border: "#CED4DA",
      background: "#CED4DA",
      hover: "#CED4DA",
    },
    primaryOpacity: {
      color: "#4529E6",
      border: "#EDEAFD",
      background: "#EDEAFD",
      hover: "#EDEAFD",
    },
    light: {
      color: "#212529",
      border: "#FDFDFD",
      background: "#FDFDFD",
      hover: "#FDFDFD",
    },
    outlineLight: {
      color: "#FDFDFD",
      border: "#FDFDFD",
      background: "#F7F7F7",
      hover: "transparent",
    },
    outline1: {
      color: "#0B0D0D",
      border: "#0B0D0D",
      background: "#F7F7F7",
      hover: "#F7F7F7",
    },
    outline2: {
      color: "#0B0D0D",
      border: "#ADB5BD",
      background: "#F7F7F7",
      hover: "#F7F7F7",
    },
    primaryOutline: {
      color: "#4529E6",
      border: "#4529E6",
      background: "#F7F7F7",
      hover: "#EDEAFD",
    },
    link: {
      color: "#0B0D0D",
      border: "transparent",
      background: "transparent",
      hover: "#F1F3F5",
    },
    alert: {
      color: "#CD2B31",
      border: "#FFE5E5",
      background: "#FFE5E5",
      hover: "#FDD8D8",
    },
    success: {
      color: "#18794E",
      border: "#DDF3E4",
      background: "#DDF3E4",
      hover: "#CCEBD7",
    },
    primaryDisable: {
      color: "#EDEAFD",
      border: "#B0A6F0",
      background: "#B0A6F0",
      hover: "#B0A6F0",
    },
  },
  brand: {
    brand1: "#4529E6",
    brand2: "#5126EA",
    brand3: "#B0A6F0",
    brand4: "#EDEAFD",
  },
  greyScale: {
    grey0: "#0B0D0D",
    grey1: "#212529",
    grey2: "#495057",
    grey3: "#868E96",
    grey4: "#ADB5BD",
    grey5: "#CED4DA",
    grey6: "#DEE2E6",
    grey7: "#E9ECEF",
    grey8: "#F1F3F5",
    grey9: "#F8F9FA",
    grey10: "#FDFDFD",
    whiteFixed: "#FFFFFF",
  },
  feedBack: {
    alert1: "#CD2B31",
    alert2: "#FDD8D8",
    alert3: "#FFE5E5",
    sucess1: "#18794E",
    sucess2: "#CCEBD7",
    sucess3: "#DDF3E4",
  },
  colorRandomProfile: {
    random1: "#E34D8C",
    random2: "#C04277",
    random3: "#7D2A4D",
    random4: "#7000FF",
    random5: "#6200E3",
    random6: "#36007D",
    random7: "#349974",
    random8: "#2A7D5F",
    random9: "#153D2E",
    random10: "#6100FF",
    random11: "#5700E3",
    random12: "#30007D",
  },
};

export const darkTheme: DefaultTheme = {
  logoColors: {
    bigTitle: "#DEE2E6",
    smallTitle: "#4529e6",
  },
  backgroundColors: {
    generalBackground: "#495057",
    headerBackground: "#212529",
    secondaryBackground: "#212529",
    bannerBackground: "#4529E6",
  },
  borders: {
    headerBorder: "#000000",
  },
  textColors: {
    title: "#FDFDFD",
    subTitle: "#5126EA;",
    primaryText: "#EDEAFD",
    secondaryText: "#4529E6",
    spantext: "#212529",
  },
  buttons: {
    primary: {
      color: "#FFFFFF",
      border: "#4529E6",
      background: "#4529E6",
      hover: "#5126EA",
    },
    default: {
      color: "#FFFFFF",
      border: "#0B0D0D",
      background: "#0B0D0D",
      hover: "#212529",
    },
    negative: {
      color: "#DEE2E6",
      border: "#DEE2E6",
      background: "#212529",
      hover: "#CED4DA",
    },
    disable: {
      color: "#495057",
      border: "#495057",
      background: "#0a0a0a",
      hover: "#0a0a0a",
    },
    primaryOpacity: {
      color: "#4529E6",
      border: "#EDEAFD",
      background: "#0a0a0a",
      hover: "#212529",
    },
    light: {
      color: "#212529",
      border: "#FDFDFD",
      background: "#FDFDFD",
      hover: "#FDFDFD",
    },
    outlineLight: {
      color: "#FDFDFD",
      border: "#FDFDFD",
      background: "#F7F7F7",
      hover: "transparent",
    },
    outline1: {
      color: "#F7F7F7",
      border: "#F7F7F7",
      background: "#495057",
      hover: "#495057",
    },
    outline2: {
      color: "#F7F7F7",
      border: "#F7F7F7",
      background: "#212529",
      hover: "#212529",
    },
    primaryOutline: {
      color: "#4529E6",
      border: "#4529E6",
      background: "#0a0a0a",
      hover: "#212529",
    },
    link: {
      color: "#FDFDFD",
      border: "transparent",
      background: "transparent",
      hover: "#495057",
    },
    alert: {
      color: "#CD2B31",
      border: "#CD2B31",
      background: "#212529",
      hover: "#FDD8D8",
    },
    success: {
      color: "#18794E",
      border: "#18794E",
      background: "#212529",
      hover: "#CCEBD7",
    },
    primaryDisable: {
      color: "#EDEAFD",
      border: "#B0A6F0",
      background: "#B0A6F0",
      hover: "#B0A6F0",
    },
  },
  brand: {
    brand1: "#4529E6",
    brand2: "#5126EA",
    brand3: "#B0A6F0",
    brand4: "#EDEAFD",
  },
  greyScale: {
    grey0: "#0B0D0D",
    grey1: "#212529",
    grey2: "#495057",
    grey3: "#868E96",
    grey4: "#ADB5BD",
    grey5: "#CED4DA",
    grey6: "#DEE2E6",
    grey7: "#E9ECEF",
    grey8: "#F1F3F5",
    grey9: "#F8F9FA",
    grey10: "#FDFDFD",
    whiteFixed: "#FFFFFF",
  },
  feedBack: {
    alert1: "#CD2B31",
    alert2: "#FDD8D8",
    alert3: "#FFE5E5",
    sucess1: "#18794E",
    sucess2: "#CCEBD7",
    sucess3: "#DDF3E4",
  },
  colorRandomProfile: {
    random1: "#E34D8C",
    random2: "#C04277",
    random3: "#7D2A4D",
    random4: "#7000FF",
    random5: "#6200E3",
    random6: "#36007D",
    random7: "#349974",
    random8: "#2A7D5F",
    random9: "#153D2E",
    random10: "#6100FF",
    random11: "#5700E3",
    random12: "#30007D",
  },
};
